<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="datastory-card">
    <div
      v-if="imgBlob"
      class="datastory-card-image"
      :style="'background-image: url(' + imgBlob + ')'"
    />
    <div v-else class="datastory-card-image" />
    <div class="datastory-card-body">
      <div class="datastory-card-title">{{ card.title }}</div>
      <div v-cms="textDescShowed" class="datastory-card-description" />
    </div>
    <div class="datastory-card-footer">
      <div class="calendar">
        <div class="icon" />
        <div class="date">{{ card.date }}</div>
      </div>
      <a
        v-if="card.url"
        :href="card.url"
        target="_blank"
        alt="Datastory link"
      >
        <div class="arrow" />
      </a>
    </div>
  </div>
</template>

<script>
import { vCmsHtml as cms, getCmsResourceBlob } from '@/services/graphql'
export default {
  components: {},
  directives: { cms },
  props: {
    card: {
      type: Object,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    textDescShowed() {
      if (this.type === 'extended') return this.card.desc
      else {
        let finalString = ''
        let regex = /(<([^>]+)>)/gi
        let parsedString = this.card.desc.replace(regex, '')
        finalString = parsedString.length <= 200 ? parsedString : parsedString.slice(0, 197) + '...'
        return finalString
      }
    },
  },
  asyncComputed: {
    imgBlob() {
      if (this.card.imgUrl) {
        return getCmsResourceBlob(this.card.imgUrl)
          .then(blob => {
            return URL.createObjectURL(blob)
          })
          .catch(ex => {
            console.log(ex)
          })
      } else return null
    },
  },
  watch: {
    // 'card.imgUrl': {
    //   immediate: true,
    //   handler(val) {
    //     if (val)
    //       getCmsResourceBlob(val)
    //         .then(blob => {
    //           this.imgBlob = URL.createObjectURL(blob)
    //         })
    //         .catch(ex => {
    //           console.log(ex)
    //         })
    //     else this.imgBlob = null
    //   },
    // },
  },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.datastory-card
  background-color: #fff
  border-radius: 8px
  box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)
  position: relative

  .mobile &
    width: 100%

  &:hover
    outline: 1px solid $corporate_color

.datastory-card-image
  background-position: center center
  background-repeat: no-repeat
  background-size: contain
  border-radius: 6px 6px 0 0
  margin-top: vw(10px)
  height: vw(140px)
  width: 100%

.datastory-card-body
  display: flex
  flex-direction: column
  padding: vw(20px)
  padding-bottom: vw(40px)

.datastory-card-title
  min-height: vw(60px)
  m-font-size(18, 26)
  color: #000
  font-weight: 600
  margin-bottom: vw(2px)

.datastory-card-description
  m-font-size(14, 22)
  color: $grey
  font-weight: 300
  margin-bottom: vw(20px)

  > p,
  > span,
  > a
    m-font-size(14, 22) !important
    color: $grey !important
    font-weight: 300 !important

  > a
    color: $corporate_color !important

.datastory-card-footer
  position: absolute
  bottom: vw(20px)
  left: vw(20px)
  align-items: center
  display: flex
  justify-content: space-between
  width: 'calc(100% - %s)' % vw(40px)

  .calendar
    align-items: center
    display: flex

    .icon
      m-icon("calendar", 16)
      margin-right: vw(6px)

    .date
      m-font-size(12, 16)
      color: $grey-dark
      font-weight: 400
      text-transform: capitalize

  .arrow
    m-icon("arrow-back-blue", 20, $corporate_color, false)
    transform: rotate(180deg)
    cursor: pointer
</style>
